import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout/Layout';
import SubNav from '../components/Layout/components/Navbar/components/SubNav';
import { specialsSubLinks } from '../constants/nav-links.const';
import Content, { HTMLContent } from '../components/Common/Content';
import PageTitle from '../components/Common/PageTitle';
import PropTypes from 'prop-types';
import DynamicArtistsList from '../components/Artists/DynamicArtistsList';

export const ArtistsListPageTemplate = ({ title, content, contentComponent, isPreviewMode }) => {
  const introComponent = contentComponent || Content;

  return (
    <section className="section">
      <div className="container">
        <div className="row">
          <div className="col col-12">
            <PageTitle title={title} content={content} contentComponent={introComponent}/>
          </div>
        </div>
      </div>
      <DynamicArtistsList isPreviewMode={isPreviewMode}/>
    </section>
  );
};

ArtistsListPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  isPreviewMode: PropTypes.bool.isRequired,
  content: PropTypes.string,
  contentComponent: PropTypes.func,
};

const ArtistsListPage = ({data}) => {
  const { markdownRemark: post } = data;
  const title = data.markdownRemark.frontmatter.title;
  const content = data.markdownRemark.html;

  return (
    <Layout title="artists">
      <div className={`sub-nav-wrapper`}>
        <SubNav subLinks={specialsSubLinks}/>
      </div>
      <ArtistsListPageTemplate title={title} content={content} contentComponent={HTMLContent} isPreviewMode={false}/>
    </Layout>
  );
}

ArtistsListPage.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object,
};

export default ArtistsListPage;

export const artistsListQuery = graphql`
    query artistsListQuery { 
        markdownRemark(frontmatter: { templateKey: { eq: "artists-list-page" } }) {
            html
            frontmatter {
                title
            }
        }
    }
`
